import { render } from "./IssuePropertyPage.vue?vue&type=template&id=192a76fa&scoped=true&ts=true"
import script from "./IssuePropertyPage.vue?vue&type=script&lang=ts"
export * from "./IssuePropertyPage.vue?vue&type=script&lang=ts"

import "./IssuePropertyPage.vue?vue&type=style&index=0&id=192a76fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192a76fa"]])

export default __exports__